import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DOOD_URL } from '@config/ws.config';

export type TcposScoPaymentState = 'waiting' | 'success' | 'fail' | 'error';

export interface TcposScoPaymentStartResponse {
  status: 'started';
}

export interface TcposScoPaymentStatusResponse {
  state: TcposScoPaymentState;
}

export interface TcposScoPaymentCancelResponse {
  status: 'cancelled';
}

export interface TcposScoPaymentErrorResponse {
  error: string;
}

@Injectable({
  providedIn: 'root',
})
export class TcposScoApiService {
  private readonly baseUrl = `${DOOD_URL}/agent/payment`;

  constructor(private readonly httpClient: HttpClient) {}

  startPayment$(agentOrderId: string): Observable<TcposScoPaymentStartResponse> {
    return this.httpClient.post<TcposScoPaymentStartResponse>(`${this.baseUrl}/start`, {
      agent_order_id: agentOrderId,
    });
  }

  getPaymentStatus$(agentOrderId: string): Observable<TcposScoPaymentStatusResponse> {
    const params = new HttpParams().set('agent_order_id', agentOrderId);
    return this.httpClient.get<TcposScoPaymentStatusResponse>(`${this.baseUrl}/status`, { params });
  }

  cancelPayment$(agentOrderId: string): Observable<TcposScoPaymentCancelResponse> {
    return this.httpClient.post<TcposScoPaymentCancelResponse>(`${this.baseUrl}/cancel`, {
      agent_order_id: agentOrderId,
    });
  }
}
